<template>
  <div
    ref="modalEl"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="confirmModalTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmModalTitle">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Schließen"
          ></button>
        </div>
        <div class="modal-body">{{ message }}</div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            {{ cancelLabel }}
          </button>
          <button type="button" class="btn btn-danger" @click="onConfirm">
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, useTemplateRef } from 'vue';
import { Modal } from 'bootstrap';

/**
 * Generisches Bestätigungsmodal (Bootstrap). Aufruf via `open(message)`,
 * Rückgabe-Promise löst mit `true` (bestätigt) oder `false` (abgebrochen /
 * weggeklickt) auf.
 */
withDefaults(defineProps<{
  title?:        string;
  confirmLabel?: string;
  cancelLabel?:  string;
}>(), {
  title:        'Bestätigung',
  confirmLabel: 'OK',
  cancelLabel:  'Abbrechen',
});

const message = ref('');
const modalEl = useTemplateRef<HTMLDivElement>('modalEl');
let   modal: Modal | null = null;
let   resolver: ((confirmed: boolean) => void) | null = null;
let   confirmed = false;

onMounted(() => {
  if (modalEl.value) {
    modal = new Modal(modalEl.value);
    // Deckt alle Schließwege ab (X, Abbrechen, Backdrop, ESC).
    modalEl.value.addEventListener('hidden.bs.modal', onHidden);
  }
});

onBeforeUnmount(() => {
  modalEl.value?.removeEventListener('hidden.bs.modal', onHidden);
  modal?.dispose();
  modal = null;
});

function open(msg: string): Promise<boolean> {
  message.value = msg;
  confirmed     = false;
  return new Promise<boolean>(resolve => {
    resolver = resolve;
    modal?.show();
  });
}

function onConfirm(): void {
  confirmed = true;
  modal?.hide();
}

function onHidden(): void {
  resolver?.(confirmed);
  resolver = null;
}

defineExpose({ open });
</script>
